import script from "./AdminProductCategoryView.vue?vue&type=script&setup=true&lang=js"
export * from "./AdminProductCategoryView.vue?vue&type=script&setup=true&lang=js"

import "./AdminProductCategoryView.vue?vue&type=style&index=0&id=78da8bdc&scoped=true&lang=scss"

import exportComponent from "../../../../node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['__scopeId',"data-v-78da8bdc"]])

export default __exports__